const state = {
    timeStart: null,
    timeEnd: null,
}
export default {
    state,
}